import React from 'react'

import overridable from '../../utils/overridable'

const PrivilegesLogoIcon = React.lazy(() => import('./priviliges.svg?react'))

export default overridable('PriviligesLogoIcon')(PrivilegesLogoIcon)
